
import { Component, Input } from '@angular/core';
import { FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-dynamic-field-options-form',
    imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule],
    templateUrl: './dynamic-field-options-form.component.html',
    styleUrls: ['./dynamic-field-options-form.component.scss']
})
export class DynamicFieldOptionsFormComponent {
    @Input({ required: true }) optionsCtrl: FormArray<FormControl<string>>;
    @Input() fieldId: number | null = null;
    public newOptionControl = new FormControl<string>('');

    addOption(): void {
        const value = this.newOptionControl.value?.trim();
        if (value && !this.optionsCtrl.value.includes(value)) {
            this.optionsCtrl.push(new FormControl<string>(value, { nonNullable: true }));
            this.newOptionControl.setValue('');
        }
    }

    removeOption(i: number): void {
        if (this.optionsCtrl.length > 1) {
            this.optionsCtrl.removeAt(i);
        }
    }

    getUniqueId(suffix: string, i?: number): string {
        const base = this.fieldId !== null && this.fieldId !== undefined ? this.fieldId : Date.now();
        return i !== undefined ? `${suffix}-${base}-${i}` : `${suffix}-${base}`;
    }

    getRemoveOptionButtonId(i: number): string {
        const optionValue = this.optionsCtrl.at(i).value;
        return this.getUniqueId(`remove-option-btn-${optionValue}`, i);
    }

    getAddOptionButtonId(): string {
        return this.getUniqueId('add-option-btn');
    }

    getAddOptionInputId(): string {
        return this.getUniqueId('add-option-input');
    }
}
